import React, { Component } from 'react';
import moment from 'moment';
// import "moment/locale/es";
import { minusSinEspacio, proximo, isMobile } from '../utils/helpers';

import Daynav from './Daynav';
import Pronav from './Pronav';
import ClaveMapa from './ClaveMapa';
import ReactGoogleMaps from './ReactGoogleMaps';
// import MyMapComponent from "./MyMapComponent";
import Ficha from './Ficha';

import { fetchForecastByCityName } from '../services/Openweathermap';

import { fechas } from '../data/fechas';
import { procesiones } from '../data/procesiones';
// import Weather from "./Weather";
// import "../css/weather-icons.min.css";

moment.locale('es');

class Inicio extends Component {
	constructor() {
		super();
		this.state = {
			tiempo: null,
			pro_act: [0],
			pro_obj: procesiones.servita,
			dia_act: '',
			dia: '',
			isMobile: '',
			loading: false,
			forecast: []
		};
		//BINDINGS
		this.diaSiguiente = this.diaSiguiente.bind(this);
		this.diaAnterior = this.diaAnterior.bind(this);
		this.calcularDia = this.calcularDia.bind(this);
		this.calcularHora = this.calcularHora.bind(this);
		this.cambioProcesionActiva = this.cambioProcesionActiva.bind(this);
	}

	componentWillMount() {
		this.calcularDia();

		this.setState({
			isMobile: isMobile()
		});
		this.getForecastData();
	}

	calcularDia() {
		const ahora = moment();
		// const ahora = moment().add(30, "d");
		// const ahora = moment('2018-03-23');
		const inicio = '2018-03-23';
		const final = '2018-04-01';
		// Antes
		if (ahora.isBefore(inicio, 'd')) {
			console.log('before');
			this.setState({
				dia_act: 1,
				dia: '',
				tiempo: fechas[1]
			});
		} else if (ahora.isAfter(final, 'd')) {
			// Después
			console.log('after');
			this.setState({
				dia_act: 10,
				dia: '',
				tiempo: fechas[10],
				pro_obj: procesiones.resucitado
			});
		} else {
			this.setState(
				{
					tiempo: fechas[ahora.diff(inicio, 'd') + 1],
					dia_act: ahora.diff(inicio, 'd') + 1,
					dia: ahora.diff(inicio, 'd') + 1
				},
				() => {
					if (this.state.dia_act !== 2) {
						this.calcularHora();
					}
				}
			);
		}
	}

	calcularHora() {
		let now = moment();
		// Descomentar arriba, esto es un test
		// let now = moment('2018-03-25T23:40');

		let procesionActiva = this.state.tiempo.procesiones_hora.reduce(
			(acc, curr, index) => {
				if (moment(now).isBetween(curr[0], curr[1])) {
					acc.push(index);
				}
				return acc;
			},
			[]
		);

		// Si no hay ninguna activa en ese momento

		let nombreProcesion = () => {
			if (procesionActiva.length === 0) {
				return minusSinEspacio(this.state.tiempo.procesiones[0]);
			} else {
				return minusSinEspacio(
					this.state.tiempo.procesiones[procesionActiva[0]]
				);
			}
		};

		this.setState({
			pro_act: procesionActiva,
			pro_obj: procesiones[nombreProcesion()]
		});
	}

	diaSiguiente() {
		if (this.state.dia_act === 1) {
			this.setState({
				dia_act: this.state.dia_act + 1,
				tiempo: fechas[this.state.dia_act + 1]
			});
		} else {
			this.setState(
				{
					dia_act: this.state.dia_act + 1,
					tiempo: fechas[this.state.dia_act + 1]
				},
				() => {
					let name = this.state.tiempo.procesiones[0];
					let nombre = minusSinEspacio(name);
					this.setState({
						pro_obj: procesiones[nombre]
					});
				}
			);
		}
	}

	diaAnterior() {
		if (this.state.dia_act === 3) {
			this.setState({
				dia_act: this.state.dia_act - 1,
				tiempo: fechas[this.state.dia_act - 1]
			});
		} else {
			this.setState(
				{
					dia_act: this.state.dia_act - 1,
					tiempo: fechas[this.state.dia_act - 1]
				},
				() => {
					let name = this.state.tiempo.procesiones[0];
					let nombre = minusSinEspacio(name);
					this.setState({
						pro_obj: procesiones[nombre]
					});
				}
			);
		}
	}

	cambioProcesionActiva(procesion) {
		if (procesion) {
			let nombre = minusSinEspacio(procesion);
			this.setState({
				pro_obj: procesiones[nombre]
			});
		}
	}

	async getForecastData() {
		this.setState({ loading: true });
		const result = await fetchForecastByCityName('Cádiz, es');
		// console.log(result);
		this.setState({
			loading: false,
			forecast: result.list.map(item => ({
				date: moment(item.dt * 1000),
				temp: item.main.temp,
				humidity: item.main.humidity,
				// rain: item.rain ? item.rain['3h'].toFixed(1) : 0,
				weather: item.weather[0]
			}))
		});
	}

	render() {
		return (
			<div>
				{/* <Weather /> */}

				<Daynav
					dia={this.state.dia}
					dia_act={this.state.dia_act}
					dia_fecha={this.state.dia_fecha}
					dia_evento={this.state.dia_evento}
					diaSiguiente={this.diaSiguiente}
					diaAnterior={this.diaAnterior}
					tiempo={this.state.tiempo}
				/>
				<Pronav
					dia={this.state.dia}
					dia_act={this.state.dia_act}
					pro_act={this.state.pro_act}
					tiempo={this.state.tiempo}
					nombre={this.state.pro_obj.nombre}
					cambioProcesionActiva={this.cambioProcesionActiva}
				/>

				{this.state.dia_act !== 2 ? (
					<div>
						<ClaveMapa
							distancia={this.state.pro_obj.distancia}
							nombre={this.state.pro_obj.nombre}
						/>
						<ReactGoogleMaps
							zoom={this.state.pro_obj.mapConfig.zoom}
							center={this.state.pro_obj.mapConfig.center}
							pathIda={this.state.pro_obj.ida}
							pathVuelta={this.state.pro_obj.vuelta}
							markers={this.state.pro_obj.markers}
							pro_obj={this.state.pro_obj}
							proximo={proximo(this.state.pro_obj.markers)}
							isMobile={this.state.isMobile}
							dia={this.state.dia}
							dia_act={this.state.dia_act}
						/>
						<Ficha
							pro_obj={this.state.pro_obj}
							dia={this.state.dia}
							dia_act={this.state.dia_act}
							cityName={'Cádiz, es'}
							forecast={this.state.forecast}
							loading={this.state.loading}
							onPressRefresh={() => this.getForecastData()}
						/>
						{/* <MyMapComponent
					zoom={this.state.pro_obj.mapConfig.zoom}
					center={this.state.pro_obj.mapConfig.center}
					pathIda={this.state.pro_obj.ida}
					pathVuelta={this.state.pro_obj.vuelta}
					markers={this.state.pro_obj.markers}
					pro_obj={this.state.pro_obj}
					proximo={proximo(this.state.pro_obj.markers)}
					isMobile={this.state.isMobile}
				/> */}
					</div>
				) : (
					''
				)}
			</div>
		);
	}
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/components/Inicio.js